export class MetaInfo implements IMetaInfo {
    title: string;
    unit: string;

    getMetaInfo(metaInfo) {
        this.title = metaInfo.title;
        this.unit = metaInfo.unit;
        return this;
    }
}